module.exports = __webpack_public_path__ + "img/2.ed558bb5.png";